import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Custom hook to scroll to top on route navigation.
 *
 * Targets the SidebarInset scroll container (which has data-sidebar-inset attribute)
 * instead of window, since the app uses a custom scrollable container.
 *
 * React Router's ScrollRestoration component does NOT support custom scroll containers,
 * so this custom implementation is required.
 *
 * @see Task 103 - Scroll-to-Top Implementation
 * @see src/components/ui/sidebar.tsx - SidebarInset has data-sidebar-inset attribute
 */
export function useScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Target SidebarInset scroll container (has data-sidebar-inset attribute)
    const scrollContainer = document.querySelector('[data-sidebar-inset]');

    if (scrollContainer) {
      scrollContainer.scrollTo({ top: 0, behavior: 'instant' });
    } else {
      // Fallback to window for pages without SidebarInset (e.g., public pages)
      window.scrollTo({ top: 0, behavior: 'instant' });
    }
  }, [pathname]);
}
